import * as API from "../apis/autographApi";
import { observable, action } from "mobx";

export default class AutographStore {
  @observable initInfo = [];
  @observable isAutoResizeSignImage = true;
  @observable recordId = "0";
  @observable visible = true;
  @observable index = "";
  @observable indexOfAutograph = "";
  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  };
  @action
  getAutographInfo = params => {
    return new Promise(resolve => {
      API.getAutographInfo(params).then(res => {
        this.initInfo = res;
        resolve(res);
      });
    });
  };

  @action
  saveAutograph = (needCheck, mul) => {
    if (!window.document[`Consult${this.index}`]) {
      return mul
        ? { indexOfAutograph: this.indexOfAutograph, recordId: -3 }
        : -3;
    }
    if (needCheck) {
      if (
        window.document[`Consult${this.index}`].DocEmpty &&
        window.document[`Consult${this.index}`].OpinionText == ""
      ) {
        return mul
          ? { indexOfAutograph: this.indexOfAutograph, recordId: -2 }
          : -2;
      }
    }
    //TODO save
    let record = "";
    const timestamp = Date.parse(new Date()) / 1000;
    if (window.document[`Consult${this.index}`].Modify) {
      // let saveFlag = window.document.Consult.SaveSignature();
      let saveFlag = this.isAutoResizeSignImage
        ? window.document[`Consult${this.index}`].SaveAsGifEx(
            timestamp + ".gif",
            "All",
            "Remote"
          )
        : window.document[`Consult${this.index}`].SaveSignature();
      if (!saveFlag) {
        return mul
          ? { indexOfAutograph: this.indexOfAutograph, recordId: -1 }
          : -1;
      }
      record = window.document[`Consult${this.index}`].WebGetMsgByName(
        "RECORDID"
      );
      if (parseInt(record) > 0 && this.isAutoResizeSignImage) {
        window.document[`Consult${this.index}`].WebSetMsgByName(
          "TEMPCALL",
          "1"
        );
        window.document[`Consult${this.index}`].WebSetMsgByName(
          "TEMPID",
          record
        );
        saveFlag = window.document[`Consult${this.index}`].SaveSignature();
      }
    } else {
      const tempResult = parseInt(this.recordId, 10) > 0 ? this.recordId : true;
      return mul
        ? { indexOfAutograph: this.indexOfAutograph, recordId: tempResult }
        : tempResult;
    }
    return mul
      ? { indexOfAutograph: this.indexOfAutograph, recordId: record }
      : record;
  };
}



// WEBPACK FOOTER //
// ./comMobx/wea-autograph/stores/autographStore.js